<template>
    <v-dialog v-model="show" max-width="600px" :persistent="loading" scrollable>
        <v-card class="pa-4">
            <v-card-title>
                Novo registro financeiro
            </v-card-title>
            <v-card-text>
                <v-form ref="formExtract">
                    <v-row>
                        <v-col v-if="error_message" cols="12">
                            <v-alert type="error darken-4">
                                {{ error_message }}
                            </v-alert>
                        </v-col>
                        <v-col v-if="success_message" cols="12">
                            <v-alert type="success">
                                {{ success_message }}
                            </v-alert>
                        </v-col>
                        <v-col :cols="12">
                            <v-select v-model="type" label="Tipo" :disabled="customerData || taxeData ? true : false"
                                :items="[
                                    { text: 'Recebido de cliente', value: 'R' },
                                    { text: 'Pagamento de despesa programada', value: 'D' },
                                ]" :rules="[basic_rules.required]" />
                        </v-col>
                        <v-col v-if="type" :cols="type === 'R' ? 6 : 12">
                            <v-autocomplete v-if="type === 'R'" v-model="customer" :items="customers_list"
                                :disabled="customerData ? true : false" label="Cliente"
                                :rules="[basic_rules.required]" />
                            <v-select v-if="type === 'D'" v-model="taxe" label="Despesa"
                                :disabled="taxeData ? true : false" :items="taxes_list"
                                :rules="[basic_rules.required]" />
                        </v-col>
                        <v-col v-if="type === 'R'" cols="6">
                            <v-select v-model="service_type" label="Tipo de serviço"
                                :disabled="customerData && sessionInfo ? true : false" :items="select_services"
                                :rules="[basic_rules.required]" />
                        </v-col>
                        <v-col cols="6">
                            <v-menu ref="extractDate" v-model="show_datepicker_extract" :close-on-content-click="false"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :value="formatDate(extract_date)" label="Data do registro"
                                        append-icon="mdi-calendar" v-bind="attrs" v-on="on"
                                        @input="$event => extract_date = formatUsa($event)"
                                        :rules="[basic_rules.required]"></v-text-field>
                                </template>
                                <v-date-picker v-model="extract_date" no-title scrollable editable
                                    @input="show_datepicker_extract = false" />
                            </v-menu>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field-money v-model="ammount_paid" label="Valor" :properties="{
                                prefix: 'R$',
                            }" :options="{
                                    locale: 'pt-BR',
                                    length: 11,
                                    precision: 2,
                                    empty: null,
                                }" />
                        </v-col>
                        <v-col cols="6">
                            <v-switch v-model="add_next_payday" color="primary-blue"
                                label="Adicionar próximo pagamento?"></v-switch>
                        </v-col>
                        <v-col cols="6">
                            <v-menu v-if="add_next_payday" ref="nextPayday" v-model="show_next_payday"
                                :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :value="formatDate(next_payday)" label="Data do próx. pagamento"
                                        append-icon="mdi-calendar" v-bind="attrs" v-on="on"
                                        @input="$event => next_payday = formatUsa($event)"
                                        :rules="[basic_rules.required]"></v-text-field>
                                </template>
                                <v-date-picker v-model="next_payday" no-title scrollable editable
                                    @input="show_next_payday = false" />
                            </v-menu>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="title" label="Título do registro" :rules="[basic_rules.required]" />
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="description" label="Descrição" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-row no-gutters justify="space-between">
                    <v-col cols="auto">
                        <v-btn :disabled="loading" :loading="loading" dark color="secondary" outlined elevation="0"
                            @click="close"><v-icon left>mdi-arrow-u-left-top</v-icon> Voltar</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn :disabled="loading" :loading="loading" dark color="primary" elevation="0"
                            @click="save">Salvar
                            <v-icon right>mdi-check-bold</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dayjs from "dayjs";
import { mapActions, mapState } from 'vuex';

dayjs.locale('pt-br');
dayjs.extend(require('dayjs/plugin/customParseFormat'));

export default {
    props: {
        value: {
            type: Boolean,
            required: false,
            default: false
        },
        customerData: {
            type: Object,
            required: false,
            default: null
        },
        taxeData: {
            type: Object,
            required: false,
            default: null
        },
        sessionInfo: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {
        return {
            show: this.value,
            basic_rules: {
                required: value => !!value || "Informação obrigatória"
            },
            show_datepicker_extract: false,
            loading: false,
            error_message: null,
            success_message: null,
            show_next_payday: false,
            next_payday: null,
            extract_date: dayjs().format('YYYY-MM-DD'),
            service_type: null,
            ammount_paid: null,
            title: null,
            customer: null,
            taxe: null,
            description: null,
            type: null,
            add_next_payday: true,
            select_services: [],
            current_contract: null
        };
    },
    computed: {
        ...mapState("customers", {
            customers_list: state => state.customers_list?.filter(customer => {
                return customer.status != 'I';
            })?.map(customer => {
                return { text: customer.name, value: customer };
            })
        }),
        ...mapState("taxes", {
            taxes_list: state => state.taxes_list?.map(taxe => {
                return { text: taxe.title, value: taxe };
            })
        }),
    },
    watch: {
        value() {
            this.show = this.value;
        },
        show() {
            if (!this.show) {
                // Resetando ao fechar
                this.$emit("close");
                this.show_datepicker_extract = false;
                this.loading = false;
                this.error_message = null;
                this.success_message = null;
                this.show_next_payday = false;
                this.next_payday = null;
                this.extract_date = null;
                this.service_type = null;
                this.ammount_paid = null;
                this.title = null;
                this.customer = null;
                this.taxe = null;
                this.description = null;
                this.type = null;
                this.add_next_payday = false;
                this.current_contract = null;
            } else {
                // Preenchendo ao abrir
                if (this.sessionInfo) {
                    this.service_type = this.sessionInfo.service.id;
                }

                if (this.customerData) {
                    const foundCustomer = this.customers_list.find(customer => {
                        return customer.value.id === this.customerData.id;
                    });
                    if (foundCustomer) {
                        this.customer = foundCustomer.value;
                    }
                }

                if (this.taxeData) {
                    this.taxe = this.taxeData;
                }
            }

            this.error_message = null;
            this.success_message = null;
            this.$emit("input", this.show);
        },
        customerData() {
            if (this.customerData) {
                this.customer = this.customers_list.find(customer => {
                    return customer.value.id === this.customerData.id;
                }).value;
            }
        },
        taxeData() {
            this.taxe = this.taxeData;
        },
        type() {
            if (!this.customerData && !this.taxeData) {
                this.show_datepicker_extract = false;
                this.show_next_payday = false;
                this.next_payday = null;
                this.extract_date = null;
                this.ammount_paid = null;
                this.title = null;
                this.customer = null;
                this.taxe = null;
                this.description = null;
                this.add_next_payday = false;
                this.service_type = null;

                this.$refs?.formExtract?.resetValidation();
            }
        },
        taxe() {
            if (this.taxe) {
                this.type = 'D';
                this.extract_date = this.taxe.due_date ?? dayjs().format('YYYY-MM-DD');
                this.ammount_paid = this.taxe.ammount / 100;
                this.title = "Pagamento de despesa - " + this.taxe.title;
                this.description = "Pagamento de despesa - " + this.taxe.title + "\n\n" + this.taxe.description;
                this.add_next_payday = this.taxe.due_date ? true : false;

                if (this.taxe.due_date) {
                    this.next_payday = dayjs(this.taxe.due_date).add(1, "month").format("YYYY-MM-DD");
                }

                this.$forceUpdate();
            }
        },
        customer() {
            if (this.customer) {
                this.type = 'R';
                this.getServicesByCustomer();
                this.fillFields();
                this.$forceUpdate();
            }
        },
        services_list() {
            this.mountSelectServices();
        },
        service_type() {
            this.fillFields();
        }
    },
    mounted() {
        dayjs.locale('pt-br');
        this.getCustomers();
        this.getTaxes();
        if (this.customerData) {
            this.customer = this.customers_list.find(customer => {
                return customer.value.id === this.customerData.id;
            }).value;

            this.getServicesByCustomer();
        }
        if (this.sessionInfo) {
            this.service_type = this.sessionInfo.service.id;
        }
        this.taxe = this.taxeData;
    },
    methods: {
        ...mapActions("extract", ["ActionDoCreateExtract"]),
        ...mapActions("customers", ["ActionDoGetCustomers"]),
        ...mapActions("taxes", ["ActionDoGetTaxes"]),
        ...mapActions("services", ["ActionDoGetServices"]),
        fillFields() {
            if (this.service_type && this.customer) {
                this.current_contract = this.customer.contracts.find(contract => {
                    return contract.service.id === this.service_type && contract.status === 'A';
                });

                if (this.current_contract) {
                    this.extract_date = this.current_contract.payday ?? dayjs().format('YYYY-MM-DD');
                    this.ammount_paid = this.current_contract.attendance_value / 100;
                    this.title = `Pagamento de atendimento - ${this.current_contract.service.name} - ${this.customer.name}`
                    this.description = "Pagamento ";
                    this.add_next_payday = this.current_contract.payday ? true : false;

                    if (this.current_contract.payday) {
                        let array_weekdays = {
                            'monday': 1,
                            'tuesday': 2,
                            'wednesday': 3,
                            'thursday': 4,
                            'friday': 5,
                            'saturday': 6,
                            'sunday': 7
                        };
                        switch (this.current_contract.billing_type) {
                            case "A":
                                this.description += "dos atendimentos de " + this.current_contract.service.name + " referente ao mês de " + dayjs(this.current_contract.payday).format("MMMM");

                                switch (this.current_contract.attendance_frequency) {
                                    case "S":
                                        if (this.current_contract.payment_frequency == 'S') {
                                            this.next_payday = dayjs(this.current_contract.payday).add(7, "day").format("YYYY-MM-DD");
                                            this.ammount_paid = this.current_contract.attendance_value / 100;
                                        } else if (this.current_contract.payment_frequency == 'Q') {
                                            this.next_payday = dayjs(this.current_contract.payday).add(2, "week").format("YYYY-MM-DD");
                                            this.ammount_paid = (this.current_contract.attendance_value * 2) / 100;
                                        } else {
                                            this.next_payday = dayjs(this.current_contract.payday).add(1, "month").format("YYYY-MM-DD");
                                            let last_day_month = dayjs(this.extract_date).endOf("month");
                                            while (last_day_month.day() !== array_weekdays[this.current_contract.week_day_attendance]) {
                                                last_day_month = last_day_month.subtract(1, "day");
                                            }

                                            this.ammount_paid = (this.current_contract.attendance_value * (last_day_month.diff(last_day_month.startOf("month"), "week") + 1)) / 100;
                                        }
                                        break;
                                    case "Q":
                                        if (this.current_contract.payment_frequency == 'S') {
                                            this.next_payday = dayjs(this.current_contract.payday).add(7, "day").format("YYYY-MM-DD");
                                            this.ammount_paid = (this.current_contract.attendance_value / 2) / 100;
                                        } else if (this.current_contract.payment_frequency == 'Q') {
                                            this.next_payday = dayjs(this.current_contract.payday).add(2, "week").format("YYYY-MM-DD");
                                            this.ammount_paid = this.current_contract.attendance_value / 100;
                                        } else {
                                            this.next_payday = dayjs(this.current_contract.payday).add(1, "month").format("YYYY-MM-DD");
                                            this.ammount_paid = (this.current_contract.attendance_value * 2) / 100;
                                        }
                                        break;
                                    case "M":
                                        if (this.current_contract.payment_frequency == 'S') {
                                            this.next_payday = dayjs(this.current_contract.payday).add(7, "day").format("YYYY-MM-DD");
                                            let last_day_month = dayjs(this.extract_date).endOf("month");
                                            while (last_day_month.day() !== array_weekdays[this.customer.week_day_attendance]) {
                                                last_day_month = last_day_month.subtract(1, "day");
                                            }
                                            this.ammount_paid = (this.current_contract.attendance_value / (last_day_month.diff(last_day_month.startOf("month"), "week") + 1)) / 100;
                                        } else if (this.current_contract.payment_frequency == 'Q') {
                                            this.next_payday = dayjs(this.current_contract.payday).add(2, "week").format("YYYY-MM-DD");
                                            this.ammount_paid = (this.current_contract.attendance_value / 2) / 100;
                                        } else {
                                            this.next_payday = dayjs(this.current_contract.payday).add(1, "month").format("YYYY-MM-DD");
                                            this.ammount_paid = this.current_contract.attendance_value / 100;
                                        }
                                        break;
                                }
                                break;
                            case "M":
                                this.ammount_paid = this.current_contract.attendance_value / 100;
                                this.description += "dos atendimentos de " + this.current_contract.service.name + " no pacote mensal referente ao mês de " + dayjs(this.current_contract.payday).format("MMMM");
                                this.next_payday = dayjs(this.current_contract.payday).add(1, "month").format("YYYY-MM-DD");
                                break;
                        }
                    }
                } else {
                    this.extract_date = dayjs().format('YYYY-MM-DD');
                    this.ammount_paid = 0;
                    this.title = `Pagamento avulso - ${this.customer.name}`;
                    this.description = "";
                    this.add_next_payday = false;
                }
            } else if (!this.service_type) {
                this.extract_date = dayjs().format('YYYY-MM-DD');
                this.ammount_paid = null;
                this.title = null;
                this.description = null;
                this.add_next_payday = false;
            }
        },
        getCustomers() {
            if (!this.customers_list) {
                this.ActionDoGetCustomers();
            }
        },
        getTaxes() {
            if (!this.taxes_list) {
                this.ActionDoGetTaxes();
            }
        },
        getServicesByCustomer() {
            if (this.$store.state.services && this.$store.state.services.services_list && this.$store.state.services.services_list.length > 0) {
                this.services_list = this.$store.state.services.services_list;
                this.mountSelectServices();
            } else {
                this.ActionDoGetServices().then(data => {
                    this.services_list = data;
                    this.mountSelectServices();
                });
            }

            if (this.sessionInfo) {
                this.service_type = this.sessionInfo.service.id;
            }
        },
        mountSelectServices() {
            if (this.services_list && this.services_list.length > 0) {
                this.select_services = this.services_list.map(service => ({
                    text: service.name,
                    value: service.id
                }));
            } else {
                this.select_services = [];
            }
        },
        formatDate(date) {
            return date ? dayjs(date).format("DD/MM/YYYY") : null;
        },
        formatUsa(date) {
            if (date) {
                if (date.length === 8) {
                    return dayjs(date, 'DDMMYYYY').format('YYYY-MM-DD');
                } else if (date.length === 10) {
                    return dayjs(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            }

            return null;
        },
        close() {
            this.$refs.formExtract.reset();
            this.show = false;
        },
        save() {
            this.loading = true;
            this.error_message = null;
            this.success_message = null;

            if (this.$refs.formExtract.validate()) {
                this.ActionDoCreateExtract({
                    extract_date: this.extract_date,
                    service_id: this.service_type,
                    ammount_paid: Number.isInteger(this.ammount_paid) ? this.ammount_paid * 100 : parseInt(this.ammount_paid.toString().replace(/[^0-9]+/g, "")),
                    type: this.type,
                    title: this.title,
                    description: this.description,
                    customer_id: this.customer?.id,
                    taxe_id: this.taxe?.id,
                    next_payday: this.add_next_payday ? this.next_payday : null
                }).then(response => {
                    if (response.extract_id) {
                        this.ActionDoGetCustomers();
                        this.success_message = "Registro adicionado com sucesso";
                        this.$refs.formExtract.reset();
                        this.loading = false;
                        this.$emit("created");
                        this.show = false;
                    } else {
                        this.error_message = "Houve um erro ao adicionar o registro";
                        this.loading = false;
                    }
                }).catch(error => {
                    console.error(error);
                    this.error_message = error.response.data;
                    this.loading = false;
                });
            } else {
                this.loading = false;
            }
        }
    }
};
</script>
